/* ===============================
   SA INSTANT PRODUCT PRELOAD
================================ */

let preloadedProducts = new Set();

document.addEventListener("mouseover", preloadProduct);
document.addEventListener("touchstart", preloadProduct, { passive: true });

function preloadProduct(e) {

  const item = e.target.closest(".similar-item");
  if (!item) return;

  const url = item.href;
  if (!url || preloadedProducts.has(url)) return;

  preloadedProducts.add(url);

  // preload HTML
  fetch(url, { priority: "low" })
    .then(() => {})
    .catch(() => {});

  // preload images
  const img = item.querySelector("img");
  if (img && img.src) {
    const preloadImg = new Image();
    preloadImg.src = img.src;
  }
}